module.exports = __webpack_public_path__ + "img/404.bca16b55.png";